const UUID_LIKE_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export function isUuidLike(value: unknown): value is string {
  return typeof value === 'string' && UUID_LIKE_RE.test(value);
}
